<template>
    <div id="incomeDetails">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
            <div class="headerText">收支明细</div>
            <img src="../assets/images/img_29.png" alt="" id="erweima" @click="inErweimaShare">
        </div>
        <!-- 头部 -->
        <div class="headerTop">
            <div class="panel">
                <div class="left">
                    <div>今日收益</div>
                    <div>{{today_income}}<span>元</span></div>
                </div>
                <div class="right">
                    <div>累计收益</div>
                    <div>{{total_balance}}<span>元</span></div>
                </div>
            </div>
            <div class="chooseSee">
                <div class="chooseBox" @click="chooseSeeBox(0)">
                    <div class="tit" :style="{fontWeight:(chooseBox == 0 ? '600' : '')}">收入明细</div>
                    <div class="line" v-show="chooseBox == 0"></div>
                </div>
                <div class="chooseBox" @click="chooseSeeBox(1)">
                    <div class="tit" :style="{fontWeight:(chooseBox == 1 ? '600' : '')}">提现记录</div>
                    <div class="line" v-show="chooseBox == 1"></div>
                </div>
            </div>
        </div>
        <!-- 收入明细 -->
        <div class="incomeSituation" v-show="chooseBox == 0" @scroll="incomeScroll">
            <div class="timeType" v-for="(items,indexs) in income" :key="indexs">
                <div class="timeAndTotal">
                    <div>{{items.day}}</div>
                    <div>收入￥{{items.income}}</div>
                </div>
                <div class="taskItem" v-for="(ite,ind) in items.list" :key="ind">
                    <div class="lefts">
                        <div class="leftsImg"><img src="../assets/images/img_77.png" alt=""></div>
                        <div class="centers">
                            <span>{{ite.des}}</span>
                            <span>{{ite.time}}</span>
                        </div>
                    </div>
                    <div class="addNum">+{{ite.money}}<span>元</span></div>
                </div>
            </div>
            <div class="onloadMore">
                <img src="../assets/images/onloadMore.gif" alt="" v-show="incomeMoreText == '加载中...'">
                <span>{{incomeMoreText}}</span>
            </div>
        </div>
        <!-- 提现记录 -->
        <div class="cashOutRecord" v-show="chooseBox == 1" @scroll="cashScroll">
            <div class="record" v-for="(ites,inds) in cashOut" :key="inds">
                <div class="monthAndTotal">
                    <div>{{ites.month}}</div>
                    <div>收入￥{{ites.cash}}</div>
                </div>
                <div class="recordItem" v-for="(t,i) in ites.list" :key="i">
                    <span class="time">{{t.time}}</span>
                    <!-- <span class="mode"><span :style="{color:(t.mode == '微信' ? '#40B035' : '#08A1F8')}">{{t.mode}}</span>提现{{t.money}}元到账户</span> -->
                    <span class="mode">{{t.des}}</span>
                </div>
            </div>
            <div class="onloadMore">
                <img src="../assets/images/onloadMore.gif" alt="" v-show="cashMoreText == '加载中...'">
                <span>{{cashMoreText}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{

        },
        data() {
            return {
                headersText:'收支明细',
                chooseBox:0,

                today_income:0,
                total_balance:0,
                // 收入明细
                income:[],
                // 提现记录
                cashOut:[],


                incomeMoreText:'加载中...',
                incomePage:1, // 收入页数
                incomeFlag:true,

                cashMoreText:'加载中...',
                cashOutPage:1, //提现页数 
                cashFlag:true
            }
        },
        created() {
            this.init();
        },
        mounted() {
            
        },
        methods: {
            // 初始化 接口调用
            init(){
                this.$loading(true);
                // 获取 收入明细
                let incomeDatas = {
                    action: 'income',
                    page: this.incomePage
                }
                this.$http.POSTS('User/incomeDetails',incomeDatas,(res)=>{
                    console.log(res.data);
                    this.today_income = res.data.today_income;
                    this.total_balance = res.data.total_balance;
                    this.income = res.data.income_list;
                    this.incomeMoreText = '上拉加载更多'
                    this.$loading(false);
                });


                // 获取 提现记录
                let cashDatas = {
                    action: 'cash',
                    page: this.cashOutPage
                } 
                this.$http.POSTS('User/incomeDetails',cashDatas,(res)=>{
                    console.log(res.data);
                    this.cashOut = res.data.cash_list;
                    this.cashMoreText = '上拉加载更多'
                });
            },

            returnPage(){
                this.$router.go(-1);
            },
            chooseSeeBox(index){
                this.chooseBox = index;
            },
            // 进入 您的分享二维码
            inErweimaShare(){
                this.$router.push('/incomeDetails/erweimaShare');
            },

            // 收入明细 上拉加载更多
            incomeScroll(event){
                let incomeScrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
                
                
                if(incomeScrollBottom == 0){
                    if(this.incomeFlag){
                        this.incomeMoreText = '加载中...';
                        let incomeDetailsData = {
                            action:'income',
                            page: ++this.incomePage
                        }
                        console.log(incomeDetailsData);
                        this.$http.POSTS('User/incomeDetails',incomeDetailsData,(res)=>{
                            console.log(res.data.income_list)
                            if(res.data.income_list.length == 0){
                                this.incomeMoreText = '没有更多数据了';
                                this.incomeFlag = false
                            } else {
                                for(var i=0;i<res.data.income_list.length;i++){
                                    this.income.push(res.data.income_list[i])
                                }
                                this.incomeMoreText = '上拉加载更多';
                            }
                            
                        })
                    }
                }
            },

            cashScroll(event){
                let cashScrollBottom = event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
                
                
                if(cashScrollBottom == 0){
                    if(this.cashFlag){
                        this.cashMoreText = '加载中...';
                        let cashDetailsData = {
                            action:'cash',
                            page: ++this.cashOutPage
                        }
                        console.log(cashDetailsData);
                        this.$http.POSTS('User/incomeDetails',cashDetailsData,(res)=>{
                            console.log(res.data)
                            if(res.data.cash_list.length == 0){
                                this.cashMoreText = '没有更多数据了';
                                this.cashFlag = false
                            } else {
                                for(var i=0;i<res.data.cash_list.length;i++){
                                    this.income.push(res.data.cash_list[i])
                                }
                                this.cashMoreText = '上拉加载更多';
                            }
                        })
                    }
                }
            }
        },

        // 页面是否需要缓存
        beforeRouteEnter(to, from, next) {
            if(from.name=='erweimaShare'){
                to.meta.keepAlive = true;
            } else {
                to.meta.keepAlive = false;
            }
            next();
        },
    }
</script>

<style lang="less" scoped>
    #incomeDetails{
        width: 100%;
        height: 100%;
        background: #FFFFFF;
        // overflow: hidden;
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            #returns{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
            #erweima{
                width: 19px;
                height: 19px;
                position: absolute;
                right: 25px;
            }
        }
        // 头部
        .headerTop{
            width: 375px;
            height: 138px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            overflow: hidden;
            .panel{
                width: 321px;
                height: 56px;
                padding: 12px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #DEDEDE;
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                margin: 8px 15px 0;
                display: flex;
                .left{
                    width: 50%;
                    border-right: 1px solid #E5E5E5;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    div{
                        &:nth-of-type(1){
                            font-size: 13px;
                            font-weight: 400;
                            color: #151515;
                        }
                        &:nth-of-type(2){
                            margin-top: 5px;
                            font-size: 24px;
                            color: rgba(229,1,19,1);
                            font-weight: bold;
                            font-family: "Qds";
                            span{
                                font-size: 13px;
                            }
                        }
                    }
                }
                .right{
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    div{
                        &:nth-of-type(1){
                            font-size: 13px;
                            font-weight: 400;
                            color: #151515;
                        }
                        &:nth-of-type(2){
                            margin-top: 5px;
                            font-size: 24px;
                            color: #151515;
                            font-weight: bold;
                            font-family: "Qds";
                            span{
                                font-size: 13px;
                            }
                        }
                    }
                }
            }
            .chooseSee{
                margin-top: 13px;
                display: flex;
                .chooseBox{
                    width: 50%;
                    color: #FFFFFF;
                    font-size: 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    line-height: 16px;
                    .tit{
                        margin-bottom: 7px;
                    }
                    .line{
                        width: 20px;
                        height: 3px;
                        border-radius: 2px;
                        background: #FFC8D2;
                    }
                }
            }
        }
        .onloadMore{
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #999999;
            img{
                width: 20px;
                height: 20px;
                margin-right: 10px;
            }
        }
        // 收入明细
        .incomeSituation{
            background: #FFFFFF;
            padding: 0 15px;
            height: calc(100% - 183px);
            overflow: scroll;
            .timeType{
                .timeAndTotal{
                    padding: 15px 0 12px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    div{
                        &:nth-of-type(1){
                            font-size:16px;
                            font-weight:600;
                            color:rgba(30,30,30,1);
                            line-height:16px;
                        }
                        &:nth-of-type(2){
                            font-size:12px;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            line-height:12px;
                        }
                    }
                }
                .taskItem{
                    padding: 15px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .lefts{
                        display: flex;
                        .leftsImg{
                            width: 40px;
                            height: 40px;
                            margin-right: 10px;
                            img{
                                width: 40px;
                                height: 40px;
                            }
                        }
                        
                        .centers{
                            display: flex;
                            flex-direction: column;
                            justify-content: space-around;
                            font-size:12px;
                            span{
                                &:nth-of-type(1){
                                    font-size:14px;
                                    color:rgba(21,21,21,1);
                                    line-height:16px;
                                }
                                &:nth-of-type(2){
                                    color:rgba(153,153,153,1);
                                }
                            }
                        }
                    }
                    .addNum{
                        margin-left: 10px;
                        font-size:20px;
                        color:rgba(230,9,26,1);
                        line-height:24px;
                        white-space: nowrap;
                        font-family: "Qds";
                        span{
                            font-size: 14px;
                        }
                    }
                }
            }
        }
        // 提现记录
        .cashOutRecord{
            background: #FFFFFF;
            padding: 0 15px;
            height: calc(100% - 183px);
            overflow: scroll;
            .record{
                .monthAndTotal{
                    padding: 15px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    div{
                        &:nth-of-type(1){
                            font-size:16px;
                            font-weight:600;
                            color:rgba(30,30,30,1);
                            line-height:16px;
                        }
                        &:nth-of-type(2){
                            font-size:12px;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            line-height:12px;
                        }
                    }
                }
                .recordItem{
                    font-size:13px;
                    color:rgba(102,102,102,1);
                    line-height:15px;
                    padding-bottom: 25px;
                    .time{
                        margin: 0 5px;
                    }
                    .mode{
                        margin-left: 15px;
                    }
                }
            }

        }
    }
</style>